import { useState } from "react";
import { ethers } from "ethers";
import BigNumber from "bignumber.js";
import ERC20ABI from "../abi/ERC20ABI.json";
import { useAtom } from "jotai";
import { tokenContractAddress } from "../stateManagement/tokenAddressAtom";

export const useHoldersList = (
  provider: ethers.ContractRunner | null | undefined
) => {
  const [data, setData] = useState<any>([]);
  const [holderAll, setHolderAll] = useState<any>([]);
  const tokenAddress = localStorage.getItem("tokenContractAddress");


  const holderList = async (limit: any, page: number) => {
    setData([]);
    const offset = (page) * 10;

    const tokenContract = new ethers.Contract(
      tokenAddress || "",
      ERC20ABI.abi,
      provider
    );

    const res = await tokenContract.getHoldersListPagination(offset, limit);
    console.log("res:", res);
    const getBalance = await Promise.all(res.map(async (address: string) => {
      const balance = await tokenContract.getHolderBalance(address);
     
      const externalCustomerId = await tokenContract.getHolderExternalId(address);  
      return {
        address: address,
        balance: new BigNumber(balance).div(new BigNumber(10).pow(18)).toString(),
        externalCustomerId: externalCustomerId
      }
    }));

    setData(getBalance);
  };

  const holderListAll = async () => {
    setHolderAll([]);
    const tokenContract = new ethers.Contract(
      tokenAddress || "",
      ERC20ABI.abi,
      provider
    );

    const res = await tokenContract.getHoldersListPagination(0, 10000);
    const getBalance = await Promise.all(res.map(async (address: string) => {
      const balance = await tokenContract.getHolderBalance(address);
      const externalCustomerId = await tokenContract.getHolderExternalId(address); 

      return {
        address: address,
        balance: new BigNumber(balance).div(new BigNumber(10).pow(18)).toString(),
        externalCustomerId: externalCustomerId
      }
    }));

    setHolderAll(getBalance);
  };

  // useEffect(() => {
  //   const getHoldersList = async (offset: any, limit: any) => {
  //     const tokenContract = new ethers.Contract(
  //       process.env.REACT_APP_CONTRACT_ADDRESS || "",
  //       ERC20ABI.abi,
  //       provider
  //     );

  //     const res = await tokenContract.getHoldersListPagination(offset, limit);
  //     setData(res);
  //   };

  //   const refreshInterval = setInterval(
  //     () => getHoldersList(test, 10).catch(console.error),
  //     5000
  //   );

  //   return () => clearInterval(refreshInterval);
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, []);

  return {
    holderList: holderList,
    holderListAll: holderListAll,
    data: data,
    holderAll: holderAll
  };
};
